export const PROVIDER_FIELD_ERRORS: Record<string, string> = {
  PROVIDER_FIELD_REQUIRED: 'errors.fieldRequired',
  PROVIDER_FIELD_TYPE_MISMATCH: 'errors.typeMismatch',
  PROVIDER_FIELD_FIXED_VALUE_VIOLATION: 'errors.fixedValueViolation',
  PROVIDER_FIELD_INVALID_FIELD_KEY: 'errors.invalidFieldKey',
  PROVIDER_FIELD_DUPLICATE: 'errors.duplicate',
  PROVIDER_FIELD_INVALID_DEFAULT_VALUE: 'errors.invalidDefaultValue',
  PROVIDER_FIELD_DATA_TYPE_LOCKED: 'errors.dataTypeLocked',
};
